import React, { useState, useEffect } from "react";

import { productApi } from "../../../product/services";

import ConfirmRequestView from "./ConfirmRequestView";

const UNKNONW_PRODUCT_ID = "not-found";

const ConfirmRequest = ({
  clientName,
  productId,
  onRequestSubmit,
  request,
  isEditing,
  requestType,
  buttons,
  paidOffline,
}) => {
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (!productId || productId === UNKNONW_PRODUCT_ID) {
      return;
    }

    productApi.getOne(productId, setProduct);
  }, [productId, setProduct]);

  return (
    <ConfirmRequestView
      {...{
        clientName,
        product,
        request,
        isUnknwon: productId === UNKNONW_PRODUCT_ID,
        onSubmit: onRequestSubmit,
        isEditing,
        requestType,
        buttons,
        paidOffline,
      }}
    />
  );
};

export default ConfirmRequest;
